// extracted by mini-css-extract-plugin
module.exports = {"status":"enrollmentStatus_status__99xqW","statusContainer":"enrollmentStatus_statusContainer__Kvnnz"};